import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import Contest from '../../components/Dashboard/Referral';
import withApollo from '../../lib/withApollo';

const ContestPage = () => {
  const router = useRouter();

  const { open } = router.query;
  return (
    <DashboardPage
      open={open}
      label="contest"
      content={<Contest />}
      shorttitle="Refer a friend"
    />
  );
};

export default withApollo(ContestPage);
